import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Toaster = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 3000); // auto-close after 3 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  const toasterStyles = {
    success: "bg-green-500 text-white",
    warning: "bg-yellow-500 text-black",
    error: "bg-red-600 text-white",
    info: "bg-indigo-700 text-white",
  };

  const selectedStyle = toasterStyles[type] || "bg-gray-500 text-white";

  return (
    <div
      className={classNames(
        "fixed top-8 left-1/2 transform -translate-x-1/2 p-2 rounded shadow-lg transition-opacity duration-500 lg:text-base text-xs",
        selectedStyle
      )}
      style={{
        zIndex: 9999, // Ensure it's on top of everything
        animation: "slideIn 0.5s ease-out, shake 1s ease-in-out 0.5s",
        opacity: 0.9, // Slight transparency to make it bright but not too intrusive
        maxWidth: "80vw", // Prevent it from getting too wide
        width: "auto", // Allow it to expand based on content length
        wordBreak: "break-word", // Ensure text breaks within container if too long
      }}
    >
      <span className="font-medium">{message}</span>
      <button
        onClick={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
        // todo fix later
        className="hidden ml-3 text-white"
      >
        ✕
      </button>
    </div>
  );
};

Toaster.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]),
  onClose: PropTypes.func,
};

export default Toaster;
